// extracted by mini-css-extract-plugin
module.exports = {"wager":"_3wLAgKE","plus":"_DrEn6-U","equal":"_1W1YQFg"};